<template>
  <el-dialog
    title="单位及职务切换"
    :visible.sync="dialogInfo.show"
    width="550px"
    :close-on-click-modal="false"
    @close="closeDia"
    destroy-on-close
  >
    <div>
      <div class="title_tip">请选择学员单位及职务的显示要求：</div>
      <el-radio style="margin-bottom: 16px;" v-model="type" :label="1">全称：同用户管理中单位及职务，如浙江省人大常委会委员</el-radio>
      <el-radio v-model="type" :label="2">简称：标准化简写单位及职务，如省人大常委会委员</el-radio>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn btntype="primary" @click.native="confirm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { classSwitchUnitPosition } from "@/api/enrollOffline";
export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          show: true,
        };
      },
    },
  },
  data() {
    return {
      type: 1,
    };
  },
  methods: {
    closeDia() {
      this.$emit("close", false);
    },
    confirm() {

      classSwitchUnitPosition({
        uuid: this.dialogInfo.classId,
        status: this.type,
      }).then(({ code, data }) => {
        if (code == 0) {
         this.$emit("close", true);
        }
      })
      
    },
  },
};
</script>

<style lang="scss" scoped>
.title_tip {
  margin-bottom: 24px;
}
</style>
